import template from './notification-list.html';
import controller from './notification-list.controller';

let notificationListComponent = {
  bindings: {},
  template,
  controller
};

export default notificationListComponent;



// WEBPACK FOOTER //
// ./client/app/components/notification/notification-list.component.js